import { createContext, useContext } from 'react';

export interface AuthState {
  /** Short-lived access token sent as `Authorization: Bearer`. */
  token: string | null;
  /** Workspace sent as `X-Workspace-ID` (set at login). */
  workspaceId: string | null;
  isAuthenticated: boolean;
  login: (accessToken: string, expiresIn: number, workspaceId: string) => void;
  logout: () => void;
  /** Attempt a silent cookie-based refresh; returns the new token or null. */
  refresh: () => Promise<string | null>;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const auth = useContext(AuthContext);
  if (auth === null) {
    throw new Error('useAuth must be used within an <AuthProvider>.');
  }
  return auth;
}
